import React from 'react';

import { Handle, Position } from 'reactflow';

import { BlockData, CustomNodeProps } from 'types';
import Parameter from '../Parameter/Parameter';
import ModelNodeHeader from './components/ModelNodeHeader';
import { NodeBody, NodeContainer, NodeWrapper } from '../ui';
import useNodeExpand from '../../../hooks/useNodeExpand';
import useHandlePosition from '../../../hooks/useHandlePosition';

const ModelNode = ({ data, id, selected, modelDirection }: CustomNodeProps<BlockData>) => {
  const { onExpandClick } = useNodeExpand({ id });
  const { handlePosition } = useHandlePosition(modelDirection);

  return (
    <NodeWrapper $isSelected={selected}>
      <NodeContainer $minWidth={300}>
        <ModelNodeHeader data={data} onExpandClick={onExpandClick} />
        <NodeBody>
          {data.parameters.map((parameter, index) => (
            <Parameter
              key={`${id}/parameter/${parameter.param}`}
              nodeId={id}
              index={index}
              isExpand={data.expand}
              isSelected={selected}
              parameter={parameter}
            />
          ))}
        </NodeBody>
        <Handle
          className={`target-handle ${handlePosition.target}`}
          type="target"
          position={handlePosition.target as Position}
          id={`${id}_target`}
        />
        <Handle
          className={`source-handle ${handlePosition.source}`}
          type="source"
          position={handlePosition.source as Position}
          id={`${id}_source`}
        />
      </NodeContainer>
    </NodeWrapper>
  );
};

export default React.memo(ModelNode);
